import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services';

export interface IChecklistOption {
  id: number;
  label: string;
  route?: string;
  checked?: boolean;
  available?: boolean;
}
@Component({
  selector: 'app-onboarding-checklist',
  templateUrl: './onboarding-checklist.component.html',
  styleUrls: ['./onboarding-checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingChecklistComponent implements OnChanges {
  private router = inject(Router);
  private authService = inject(AuthService);

  @Input() options: IChecklistOption[];

  ngOnChanges() {
    const firstUnFilled = this.options.findIndex((el) => !el.checked);
    if (firstUnFilled != -1) {
      this.options[firstUnFilled].available = true;
    }
  }

  public trackByFn(option: IChecklistOption): string {
    return option.label;
  }

  public onActionClick(item: IChecklistOption) {
    switch (item.id) {
      case 1:
        this.authService.showAuthModal();
        break;
      default:
        if (item.route) {
          void this.router.navigate([item.route]).then();
        }
    }
  }
}
